import { createRoot } from 'react-dom/client';
import { App } from './App';
import './generated/legacy.css';

createRoot(document.getElementById('root')!).render(<App />);
